export const prefixParticipants =
  'configuration.lmsProfiles.profileSettings.participants'

export const prefixSegments =
  'configuration.lmsProfiles.profileSettings.segments'

export const prefixForm = 'configuration.lmsProfiles.form'
